import { render, staticRenderFns } from "./CustomerSearchResult.vue?vue&type=template&id=0fe48516&scoped=true"
import script from "./CustomerSearchResult.vue?vue&type=script&lang=ts"
export * from "./CustomerSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSearchResult.vue?vue&type=style&index=0&id=0fe48516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe48516",
  null
  
)

export default component.exports